
import { useRef, useState } from 'react'
import Script from "next/script";

// export const listContainer = ({ props }) => (
export const textContainer = props => (
  <>
    <div className="container mx-auto builder-container">
      <div className="box-border h-auto w-auto p-4 border-1">
        <h3>{props.title}</h3>
      </div>
      <div className="box-border h-auto w-auto p-4 border-1">
        {props.textblocks?.map((o) => (
          <p key={o.text}>{o.text}</p>
        ))}
      </div>
    </div>
  </>
)